// React
import React from "react";
import { useParams } from "react-router-dom";

// Helper Imports
import { formatDate } from "../../../../../Helpers/formatters";

// MUI Imports
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import ToolTip from "../../../../../Components/Interactive/ToolTip";

const Five9Body = ({ callLogs }) => {
  const { id } = useParams();
  const fetchZipFiles = async (sid, c, cT, a) => {
    const query = `sessionId=${sid}&campaign=${c}&callTimestamp=${cT}&ani=${a}`;
    const res = await fetch(`/api/customer/${id}/download-call-logs?${query}`, {
      method: "GET",
      credentials: "include",
    });
    // Get the data as Array Buffer
    const data = await res.arrayBuffer();

    // Convert the buffer array to a UintArray and then to a blob to be processed
    const processedUint = new Uint8Array(data);
    const convertedBlob = new Blob(([processedUint]), {
      type: "zip",
    });

    // Make this file download
    const fileURL = URL.createObjectURL(convertedBlob);
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = "callogs.zip";
    link.click();
    window.URL.revokeObjectURL(link);
  };

  return (
    <>
      <TableBody>
        {callLogs?.map((row, index) => {
          return (
            <TableRow key={index} data-sess-id={row.sessionId}>
              <TableCell className="tableCell" align="center">
                {formatDate(row.timestamp)}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {row.campaign}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {row.campaignType}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {row.agent}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {row.disposition}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {row.callTime}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {row.ivrTime}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {row.queueWaitTime}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {row.holdTime}
              </TableCell>
              <ToolTip
                placement="top"
                titleHeading={`${row.ivrPath}`}
                titleData={row.ivrPath}
              >
                <TableCell className="tableCell" align="center">
                  {row?.ivrPath ? `${row.ivrPath.slice(0, 100)}...` : null}
                </TableCell>
              </ToolTip>
              <TableCell className="tableCell" align="center">
                {row.ani}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {row.dnis}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {row.showDownload ? (
                  <button
                    onClick={() =>
                      fetchZipFiles(
                        row.sessionId,
                        row.campaign,
                        row.timestamp,
                        row.ani
                      )
                    }
                    className="view-meta-btn"
                  >
                    <span>Download</span>
                  </button>
                ) : (
                  <p>No Call to Download</p>
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </>
  );
};

export default Five9Body;
